export const sources = {
	webp: "__VITE_ASSET__TX5a1iViCylaCWPFSCQG2w__ 500w, __VITE_ASSET__OestAvA2SyLT4CG6L76dAw__ 800w, __VITE_ASSET__U6muqRGa8aHtq8t0c9wAzg__ 1080w, __VITE_ASSET__i2ywl_YzKp2MjtOEr7ngzA__ 1440w"
};
export const img = {
	src: "__VITE_ASSET__i2ywl_YzKp2MjtOEr7ngzA__",
	w: 1440,
	h: 720
};
export default {
	sources: sources,
	img: img
};
